<router-outlet></router-outlet>

<!--(activate)="onActivate($event)" -->